module.exports = __webpack_public_path__ + "static/media/access.b831f44e.svg";